// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3kwcl","title":"Header_title__3QcZj","left":"Header_left__3spG7","clinicName":"Header_clinicName__3JN3C"};